function eq(e,n){return e===n||e!=e&&n!=n}module.exports=eq;